<template>
  <v-container fluid class="px-4 px-md-8">
    <v-row>
      <v-col>
        <p class="headline font-weight-bold">Resumen de tu pedido</p>
        <v-alert border="left" outlined type="success">Muchas gracias por su pedido. Marchandooo...</v-alert>
        <v-row>
          <v-col cols="12" md="7">
            <v-card tile outlined>
              <v-list-item class="px-4 px-md-8 pt-4 pb-0">
                <v-list-item-content class>
                  <v-list-item-title
                    class="headline font-weight-bold"
                  >{{nombreNegocio}} - {{nombreRestaurante}}</v-list-item-title>
                  <v-list-item-subtitle class="text-capitalize">De</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon
                  class="headline font-weight-bold grey--text"
                >Order #{{numPedidoRest}}</v-list-item-icon>
              </v-list-item>

              <v-list>
                <template v-for="(item, index) in items()">
                  <v-list-item v-if="item.action && item.resultado" :key="item.title">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-title>{{ item.resultado }}</v-list-item-title>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider v-else-if="item.divider" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card>
            <!--<completaRegistro />-->
          </v-col>
          <v-col cols="12" md="5">
            <v-card tile outlined>
              <v-list class="ma-0 pa-0">
                <v-list-item class="px-4 px-md-8 pt-4 pb-0">
                  <v-list-item-content class>
                    <v-list-item-title class="headline font-weight-bold">Tu pedido</v-list-item-title>
                    <v-list-item-subtitle
                      class="text-capitalize"
                    >{{nombreNegocio}} - {{nombreRestaurante}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-icon class>
                    <v-btn
                      disabled
                      small
                      elevation="1"
                      rounded
                      class="textTNone black--text"
                      @click="factura"
                    >Factura online</v-btn>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
              <v-card-text class="text--primary px-4 px-md-8 pt-4 pb-0">
                <pedirCarritoContenido
                  v-bind:opciones="{
                  select: false,
                  isResumen: true,
                  totales: true
                  }"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import pedirCarritoContenido from "@/components/Pedidos/pedir_carrito_contenido.vue";
import completaRegistro from "@/components/TuCuenta/tuCuenta_completaRegistro.vue";

export default {
  components: {
    pedirCarritoContenido,
    completaRegistro
  },
  data() {
    return {
      inset: false,
      checkbox: false,
      validForm: false,
      name: "",
      nameRules: [
        v => !!v || "Introduzca su nombre",
        v => v.length > 2 || "Es desmasiado corto"
      ],
      email: "",
      emailRules: [
        v => !!v || "Intorduzca su Email",
        v => /.+@.+/.test(v) || "Email mal escrito"
      ],
      ultimoPedido: null
    };
  },
  computed: {
    ...mapState({
      isLogged: state => state.auth.isLogged
      //formaPago: state => state.config.formaPago
    }),
    ...mapGetters({
      //ultimoPedido: "pedido/resumenUltimoPedido"
    }),
    nombreNegocio() {
      return this.ultimoPedido && this.ultimoPedido.copyNegocio
        ? this.ultimoPedido.copyNegocio.nombre
        : "Sin nombre";
    },
    nombreRestaurante() {
      return this.ultimoPedido && this.ultimoPedido.copyRest
        ? this.ultimoPedido.copyRest.nombre
        : "Sin nombre";
    },
    numPedidoRest() {
      return this.ultimoPedido ? this.ultimoPedido.numPedidoRest : "Sin número";
    },
    direccion() {
      return this.ultimoPedido && this.ultimoPedido.direccion
        ? this.ultimoPedido.direccion.calle
        : false;
    },
    modo() {
      return this.ultimoPedido && this.ultimoPedido.modo
        ? this.ultimoPedido.modo
        : false;
    },
    fecha() {
      const tz =
        this.ultimoPedido && this.ultimoPedido.copyRest.zonaHoraria
          ? this.ultimoPedido.copyRest.zonaHoraria
          : "Europe/Madrid";
      return this.ultimoPedido && this.ultimoPedido.fechaServidor
        ? moment(this.ultimoPedido.fechaServidor.toDate())
            .tz(tz)
            .format("DD-MM-YYYY HH:mm")
        : "Sin fecha";
    },
    formaPago() {
      if (this.ultimoPedido && this.ultimoPedido.forma_pago) {
        switch (this.ultimoPedido.forma_pago) {
          case "tarjeta_domicilio":
            return "Tarjeta domicilio";
            break;
          case "tarjeta_online":
            return "Tarjeta online";
            break;
          case "efectivo":
            return "Efectivo";
            break;
          case "local":
            return "Pagar en local";
            break;
        }
      } else {
        return "Sin especificar";
      }
    },
    cambio() {
      if (
        this.ultimoPedido &&
        this.ultimoPedido.forma_pago == "efectivo" &&
        this.ultimoPedido.cambio
      ) {
        return this.ultimoPedido.cambio;
      } else {
        return null;
      }
    },
    tiempo() {
      switch (this.ultimoPedido && this.ultimoPedido.modo) {
        case "domicilio":
          return this.ultimoPedido.copyRest.tiempoDomicilio;
          break;
        case "recoger":
          return this.ultimoPedido.copyRest.tiempoRecogida;
          break;
      }
    }
  },
  methods: {
    ...mapActions({}),
    items() {
      return [
        {
          action: "mdi-check",
          title: "Dirección de envio",
          resultado: this.direccion
        },
        {
          divider: true
        },
        {
          action: "mdi-delete",
          title: "Fecha y hora",
          resultado: this.fecha
        },
        {
          divider: true
        },
        {
          action: "mdi-send",
          title: "Forma de pago",
          resultado: this.formaPago
        },
        {
          divider: true
        },
        {
          action: "mdi-send",
          title: "Modo",
          resultado: this.modo
        },
        {
          divider: true
        },
        {
          action: "mdi-delete",
          title: "Cambio",
          resultado: this.cambio
        },
        {
          divider: true
        },
        {
          action: "mdi-delete",
          title: "Tiempo estimado",
          resultado: "Aprox. " + this.tiempo + " min."
        }
      ];
    },
    factura() {
      this.$store
        .dispatch("pedido/generarFactura", {
          idPedido: this.$store.state.pedido.ultimoPedido.id
        })
        .then(r => {
          console.log(r);
        });
    },
    registrar() {
      let data = {
        name: this.name,
        email: this.email
      };
      console.log(data);
    },
    devolverFormaPago() {
      let _vue = this;
      let res = this.formaPago.find(e => {
        return e.id == _vue.ultimoPedido.forma_pago;
      });
      return res;
    }
  },
  mounted() {
    this.$store.dispatch("pedido/getUltimosPedidos").then(r => {
      console.log(r);
      this.ultimoPedido = this.$store.state.pedido.ultimosPedidos[0];
    });

    this.$store.commit(
      "pedido/setUltimoPedido",
      JSON.parse(localStorage.getItem("ultimoPedido"))
    );
  },
  watch: {}
};
</script>
<style scoped>
</style>